import React from "react";
import "./template.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome/index";
import EmailForm from "../components/EmailForm/emailForm.js";
import { Link } from "react-router-dom";

const Center = ({ data, props }) => {
  const centerView = centerAction => {
    switch (centerAction.type) {
      case "link":
        return centerAction.external ? (
          <a
            target={"_blank"}
            rel="noopener noreferrer"
            className={"Center-link mankSans " + centerAction.class}
            href={centerAction.url}
          >
            {centerAction.text}{" "}
            {centerAction.icon && <FontAwesomeIcon icon="chevron-right" />}
          </a>
        ) : (
          <Link
            className={"Center-link mankSans " + centerAction.class}
            to={centerAction.url}
          >
            {centerAction.text}{" "}
            {centerAction.icon && <FontAwesomeIcon icon="chevron-right" />}
          </Link>
        );
      case "signup-btn":
        return props && props.submitted ? null : (
          <EmailForm inputInfo={centerAction} />
        );
      default:
        return null;
    }
  };

  const paragraphView = (paragraph, paragraphClass) => {
    let view = Array.isArray(paragraph) ? (
      paragraph.map((pg, idx) => {
        if (typeof pg === "object" && pg.text) {
          return (
            <p className={pg.class || ""} key={"paragraph" + idx}>
              {pg.text}
            </p>
          );
        } else {
          return { ...pg, key: "paragraph" + idx };
        }
      })
    ) : paragraph.text ? (
      <p className={paragraph.class || ""}>{paragraph.text}</p>
    ) : (
      <p>{paragraph}</p>
    );
    if (paragraphClass) {
      view = <div className={paragraphClass || ""}>{view}</div>;
    }
    return view;
  };
  return (
    <div id={data.id || ""} className={"Center " + data.class}>
      {props && props.submitted ? (
        <h1 className={data.submittedText.title.class}>
          {data.submittedText.title.text}
        </h1>
      ) : data.title && data.title.text ? (
        <h1 className={data.title.class}>{data.title.text}</h1>
      ) : null}

      {props &&
      props.submitted &&
      data.submittedText &&
      data.submittedText.paragraph
        ? paragraphView(data.submittedText.paragraph)
        : data.paragraph &&
          data.paragraph.length > 0 &&
          paragraphView(data.paragraph, data.paragraphClass)}

      {data.centerAction &&
        data.centerAction.type &&
        centerView(data.centerAction)}
    </div>
  );
};

export default Center;
